import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

export class UserConfiguration {
  headquartersSwitch?: boolean;

  constructor(userConfiguration: MSafeAny) {
    this.headquartersSwitch = userConfiguration.headquarters_switch;
  }
}
